import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  standalone: true,
  selector: 'app-file-upload-popup',
  templateUrl: './file-upload-popup.component.html',
  styleUrls: ['./file-upload-popup.component.css'],
  imports: [CommonModule, MatButtonModule, MatIconModule]
})
export class FileUploadPopupComponent {
  selectedFile: File | null = null;

  constructor(
    public dialogRef: MatDialogRef<FileUploadPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onFileSelected(event: any): void {
    this.selectedFile = event.target.files[0] || null;
  }

  uploadFile(): void {
    if (this.selectedFile) {
      this.dialogRef.close(this.selectedFile);
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  clearFile(){
    this.selectedFile = null;
  }
}
